module.exports = __webpack_public_path__ + "static/img/bb.6eab019e.svg";